import { useSearchParams } from 'react-router';
import useRegistrationIntentQuery from './queries/useRegistrationIntentQuery';
import {
  invitationTokenParamName,
  subscriptionIdParamName,
} from './Register.constants';

const useRegistrationIntent = () => {
  const [searchParams] = useSearchParams();
  const esid = searchParams.get(subscriptionIdParamName) ?? undefined;
  const it = searchParams.get(invitationTokenParamName) ?? undefined;
  const mockStatus = searchParams.get('mockStatus');
  const mockType = searchParams.get('mockType');
  const mockError = searchParams.get('mockError');

  return useRegistrationIntentQuery({
    esid,
    it,
    mockStatus,
    mockType,
    mockError,
  });
};

export default useRegistrationIntent;
